import { api } from '../../ApiHandler';
import { CompleteUser } from '../../../types';

type Props = { email: string; password: string };

export const LoginRequest = ({
	email,
	password,
}: Props): Promise<{ data: CompleteUser }> => {
	return api()
		.post('auth/login', { email, password })
		.then(response => response.data);
};
